import React from 'react';
import { withRouter } from 'react-router-dom';

import AuthUserContext from './AuthUserContext';
import {auth} from '../firebaseApp';
import * as routes from '../Constants/routes';

const withAuthorization = (authCondition) => (Component) => {
  class WithAuthorization extends React.Component {
    componentDidMount() {
      this.removeListner = auth.onAuthStateChanged(authUser => {
        if (!authCondition(authUser)) {
          this.props.history.push(routes.LANDING);
        }
      });
    }

    componentWillUnmount() {
      this.removeListner();
  }

    render() {
      return (
        <AuthUserContext.Consumer>
          {authUser => authUser ? <Component authUser={authUser} /> : null}
        </AuthUserContext.Consumer>
      );
    }
  }

  return withRouter(WithAuthorization);
}

export default withAuthorization;



// WEBPACK FOOTER //
// ./src/Session/withAuthorization.js